'use client';

import { useEffect } from 'react';

/** Tracks how many modals/drawers are currently open globally */
let openCount = 0;

/**
 * Locks body scroll while `isLocked` is true.
 * Targets both <html> and <body> to cover all scroll containers in Next.js.
 * Safe to use in multiple modals simultaneously — scroll is only
 * restored once every modal that called this hook has closed.
 */
export const useBodyScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (!isLocked) return;

    openCount += 1;

    const html = document.documentElement;
    const body = document.body;

    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';

    return () => {
      openCount -= 1;
      if (openCount <= 0) {
        openCount = 0;
        html.style.overflow = '';
        body.style.overflow = '';
      }
    };
  }, [isLocked]);
};
